<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import axios, { type AxiosResponse } from 'axios'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const { login } = useAuthStore()
const router = useRouter()

type GoogleTokenResponse = {
  access_token: string
  token_type: string
  expires_in: number
  scope: string
  refresh_token: string
  id_token: string
}

const getGoogleToken = async (
  code: string,
): Promise<AxiosResponse<GoogleTokenResponse> | unknown> => {
  try {
    const data = {
      grant_type: 'authorization_code',
      client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID, // 클라이언트 ID
      client_secret: import.meta.env.VITE_GOOGLE_CLIENT_SECRET, // 클라이언트 시크릿
      redirect_uri: import.meta.env.VITE_GOOGLE_REDIRECT_URL,
      code: code,
    }

    const queryString = Object.keys(data)
      .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(data[k as keyof typeof data]))
      .join('&')

    const result = await axios.post('https://oauth2.googleapis.com/token', queryString, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    })

    const signupRequest = await login({
      socialKey: result.data.id_token,
      socialType: 'GOOGLE',
    })

    if (signupRequest.redirect) {
      router.push({
        path: signupRequest.redirect,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        state: { signupRequest: signupRequest as Record<string, any> },
      })
    } else {
      router.push('/')
    }
    return result
  } catch (e) {
    if (e instanceof Error) {
      alert(e.message)
      router.push('/login')
    }
    console.error(e)
    return e
  }
}

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search)

  if (urlParams.has('code')) {
    const code = urlParams.get('code')
    getGoogleToken(code ?? '')
  }
})
</script>

<template>
  <div></div>
</template>
